import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import Logo from '../assets/logo.png'; // Ensure your logo is here

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  // Effect to handle "shrink on scroll"
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Navbar 
      expand="lg" 
      fixed="top" 
      className={`transition-all duration-300 ${
        scrolled ? 'py-2 bg-white shadow-lg' : 'py-4 bg-transparent'
      }`}
      style={{ transition: '0.4s ease-in-out' }}
    >
      <Container>
        <Navbar.Brand href="#home" className="d-flex align-items-center">
          <img
            src={Logo}
            alt="Viriya Logo"
            height={scrolled ? "50" : "70"} // Logo shrinks when you scroll
            className="transition-all"
            style={{ transition: '0.4s' }}
          />
          <div className="ms-2 d-none d-sm-block">
            <span className={`fw-bold mb-0 h4 ${scrolled ? 'text-success' : 'text-dark'}`}>VIRIYA</span>
            <div className="small text-muted mt-n1" style={{ fontSize: '15px', letterSpacing: '1px' }}>INTERNATIONAL SCHOOL</div>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0 shadow-none" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center gap-lg-4">
            <Nav.Link href="#home" className="nav-link-custom">Home</Nav.Link>
            <Nav.Link href="#programs" className="nav-link-custom">Programs</Nav.Link>
            <Nav.Link href="#gallery" className="nav-link-custom">School Life & Campus</Nav.Link>
            <Nav.Link href="#about" className="nav-link-custom">About</Nav.Link>
            
            <Button 
              href="#admission" 
              variant="success" 
              className="rounded-pill px-4 py-2 fw-bold shadow-sm ms-lg-2"
            >
              Apply Now
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;